import { IS_NATIVE_APP_CLIENT } from './helpers';
import { Customer } from './environment';
import { getPageType } from './gtm-data-layer';

export const identifyUserInFullStory = () => {
  try {
    const userId = Customer?.id?.toString();
    const userEmail = Customer?.email;

    if (userId) {
      window.FS('setIdentity', {
        uid: userId,
        properties: {
          displayName: userEmail,
          email: userEmail,
        },
      });
    } else {
      window.FS('setIdentity', { anonymous: true });
    }
  } catch (error) {
    console.error('Error capturing user on page load:', error);
  }
};

export const fireFSMenuLinkTracking = (link: HTMLAnchorElement) => {
  try {
    const { dataset, innerText, href } = link;

    const properties = {
      link_id: dataset.nav,
      link_text: innerText,
      link_url: href,
    };

    window.FS('trackEvent', {
      name: 'fs_menu_link',
      properties,
    });
  } catch (err) {
    console.error(err);
  }
};

export const pushPageViewEventToFS = (additionalProps: object = {}) => {
  try {
    if (IS_NATIVE_APP_CLIENT) return;

    const { host, pathname } = window.location;

    window.FS('setProperties', {
      type: 'page',
      properties: {
        pageName: `${host}${pathname}`,
        page_type: getPageType(pathname),
        user_id: Customer?.id?.toString() || '',
        ...additionalProps,
      },
    });
  } catch (err) {
    console.error('Error caputring FS page properties', err);
  }
};
